import { render, staticRenderFns } from "./MyOrdersPatentProvider.vue?vue&type=template&id=a136df8c&scoped=true"
import script from "./MyOrdersPatentProvider.vue?vue&type=script&lang=js"
export * from "./MyOrdersPatentProvider.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersPatentProvider.vue?vue&type=style&index=0&id=a136df8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a136df8c",
  null
  
)

export default component.exports